import { render, staticRenderFns } from "./InterestPublicRegister.vue?vue&type=template&id=6440fb96&"
import script from "./InterestPublicRegister.vue?vue&type=script&lang=js&"
export * from "./InterestPublicRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports